export const ExcelDateToJSDate = (date: number) => {
  const convertedDate = new Date(Math.round((date - 25569)*86400*1000 ));
  const dateStr = convertedDate.toISOString();
  const dateStrSplit = dateStr.split('T');
  const year = dateStrSplit[0].split('-')[0];
  const month = dateStrSplit[0].split('-')[1];
  const day = dateStrSplit[0].split('-')[2];
  return `${month}/${day}/${year}`;
}
